import "#legacy/shared/components/slider.js";

class SlideshowBehavior extends Sparkle.PageBuilder.Components.Behavior {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    return Sparkle.Components.Slider.initialize(this.el.find('[data-component-plugin="slick"]'));
  }
}
SlideshowBehavior.register("slideshow");
